import { Link } from 'react-router-dom';
import { darkTheme } from '../../lib/tokens';
import { PIPELINES, PLANNED } from './data';
import { formatDate } from './formatDate';

/**
 * Einstieg in die Pipeline-Dokumentation (CUR-1571).
 *
 * Adressat ist ein Gast im Termin, nicht der taegliche Admin-Nutzer: die Seite
 * erklaert zuerst, was eine Pipeline hier ueberhaupt ist, und listet dann die
 * beschriebenen Strecken.
 */
export function PipelineOverviewPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-5xl">
      <header>
        <p className="text-xs font-bold uppercase tracking-widest" style={{ color: darkTheme.colors.accentLight }}>
          Technologie
        </p>
        <h1 className="mt-1 text-2xl font-bold text-text-primary">Wie der Lernstoff entsteht</h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-text-secondary">
          Lerninhalte entstehen hier nicht als Fließtext, den jemand tippt, sondern als Fertigungsstrecke aus
          klar geschnittenen Stufen. Jede Stufe hat einen definierten Eingang, schreibt genau ein Artefakt und
          wird von einem Wächter begleitet, der eine benannte Zusage trägt — und dessen Blindstellen ebenfalls
          benannt sind.
        </p>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-text-secondary">
          Die folgenden Seiten beschreiben die beiden ausgebauten Strecken. Alle Zahlen tragen ihre Herkunft:
          den Befehl oder die Datei, aus der sie stammen.
        </p>
      </header>

      <section className="mt-8">
        <h2 className="text-lg font-bold text-text-primary">Beschriebene Strecken</h2>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          {PIPELINES.map((p) => (
            <Link
              key={p.slug}
              to={`/pipelines/${p.slug}`}
              className="flex flex-col rounded-md border p-5 transition-colors hover:border-accent-light"
              style={{ background: darkTheme.colors.bgSurface, borderColor: darkTheme.colors.borderSubtle }}
            >
              <h3 className="text-lg font-bold text-text-primary">{p.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-text-secondary">{p.claim}</p>
              <div className="mt-4 flex flex-wrap gap-x-5 gap-y-1 text-xs text-text-tertiary">
                <span>{p.stages.length} Stufen</span>
                <span>{p.gates.length} Wächter</span>
                <span>Stand {formatDate(p.asOf)}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-bold text-text-primary">Weitere Strecken, hier noch nicht beschrieben</h2>
        <p className="mt-1 text-sm text-text-secondary">
          Es gibt sie im Betrieb — die Beschreibung fehlt noch. Sie stehen hier, statt stillschweigend zu
          fehlen.
        </p>
        <div className="mt-4 grid gap-3 md:grid-cols-2">
          {PLANNED.map((p) => (
            <article
              key={p.slug}
              className="rounded-md border border-dashed p-4"
              style={{ borderColor: darkTheme.colors.borderSubtle }}
            >
              <h3 className="text-sm font-semibold text-text-tertiary">{p.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-text-tertiary">{p.teaser}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
